import React from 'react'
import { Link, Stack, Typography } from '@mui/material'
import { UIMatch, useLocation, useMatches, useParams, Params, useNavigate } from 'react-router-dom'

import { Icon } from './icon.tsx'

type Title = string | ((params: Readonly<Params>) => string)
type RouteHandle = { title: Title; goBack: boolean; pathTitle?: Title }

export const LayoutTitle = (): React.ReactElement | null => {
  const matches = useMatches() as UIMatch<unknown, RouteHandle>[]
  const { pathname } = useLocation()
  const params = useParams()
  const navigate = useNavigate()

  const matchIdx = matches.findIndex(({ pathname: matchPathname }) => matchPathname === pathname)
  const currentRoute = matches[matchIdx].handle ?? {}
  //const parentRoute = matches[matchIdx - 1]?.handle ?? {}

  const resolvedHeader = typeof currentRoute.title === 'function' ? currentRoute.title(params) : currentRoute.title

  if (!currentRoute.goBack && !resolvedHeader) {
    return null
  }

  return (
    <Stack spacing={1.5} sx={{ my: 6 }}>
      {currentRoute.goBack && (
        <Link
          onClick={() => navigate(-1)}
          color="text.primary"
          sx={({ typography }) => ({
            fontSize: typography.body1.fontSize,
            display: 'flex',
            alignItems: 'center',
            fontWeight: '500',
            cursor: 'pointer',
          })}
        >
          <Icon name="ArrowLeft" size="lg" colorScheme="text.primary" />
          Назад
          {/*typeof parentRoute.pathTitle === 'function' ? parentRoute.pathTitle(params) : parentRoute.pathTitle*/}
        </Link>
      )}
      {resolvedHeader && <Typography variant="h2">{resolvedHeader}</Typography>}
    </Stack>
  )
}
